import { cloneElement, useState, useEffect } from '@wordpress/element';
import { useSearchParams } from 'react-router-dom';
const StoreProvider = props => {
    const [data, setData] = useState({
        page: 1,
        isLoading: true,
        isLoadingCategories: true,
        totalHits: null,
        posts: null,
        categories: null,
    });

    let [searchParams] = useSearchParams();
    const page = searchParams.get('page') ? searchParams.get('page') : 1;
    const category = searchParams.get('typ') ? searchParams.get('typ') : null;

    useEffect(() => {
        const fetchData = async () => {
            setData({
                ...data,
                isLoading: true
            })
            try {
                //Get language from url.
                const pathName = window.location.pathname;
                const language = pathName.substring(0, 3).replace('/', '');

                let categories = data.categories;
                if (props.fetchCategories && !data.categories) {
                    const resTaxonomy = await fetch(`/wp-json/wp/v2/typ?lang=${language}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });

                    if (!resTaxonomy.ok) {
                        throw new Error(`Response status: ${resTaxonomy.status}`);
                    }
                 
                    categories = await resTaxonomy.json();
                }
                
                const res = await fetch(`/wp-json/wp/v2/${props.type}?lang=${language}&per_page=${props.perPage}&page=${page}${category ? `&typ=${category}` : ''}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (!res.ok) {
                    throw new Error(`Response status: ${res.status}`);
                }
             
                const posts = await res.json();

                setData({
                    page,
                    totalHits: res.headers.get('X-WP-Total'),
                    posts: posts,
                    isLoading: false,
                    isLoadingCategories: false,
                    categories
                });
            } catch (e) {
                console.log(e);
                setData({
                    ...data,
                    isLoading: false
                })
                throw e;
            } 
        };
        fetchData();
    }, [props.type, props.fetchCategories, category, page]);



    return cloneElement(props.children, {
        ...props,
        ...data
    });
};

export default StoreProvider;